<template>
  <div class="ea">
    <div class="gdzb" @click="toPage('/viewpoint_live')">观点直播</div>
    <!-- <div class="zjfw" @click="toPage('/expert_online')">专家服务</div> -->
    <!-- <div class="zzx" @click="toPage('/early_know')">早知晓FM</div> -->
    <div v-if="level >= 3" class="wxjp" @click="toPage('/live_lesson')">精品讲堂</div>
    <div v-if="level >= 3" class="rdjj" @click="toPage('/hot_focus')">热点聚焦</div>
    <div class="cyzb" @click="toLiveRoom">视频解盘</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      level: -1,
      token: ""
    };
  },
  mounted: function() {
    this.level = this.$route.query.level;
    this.token = this.$route.query.token;
  },
  methods: {
    // 跳转到慧选股直播间
    toLiveRoom: function() {
      ydClient.toLiveRoom(1);
    },
    // 跳转页面
    toPage: function(path) {
      if (this.token) {
        this.$router.push({
          path: path,
          query: {
            token: this.token
          }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "~assets/less/variables.less";
@import "../../../static/css/expertAnalyse.css";

/* .ea {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: #1D1F23;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.ea > div {
  margin-top: 25px;
  font-size: 16px;
  color: #F0F0F0;
  padding-top: 80px;
  background-repeat: no-repeat;
  background-size: 70px;
  background-position: center top;
  white-space: nowrap;
  text-align: center;
  flex: 0 0 33%;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
    color: #169DFF;
  }
  &.gdzb {
    background-image: url(~assets/images/ea_gdzb.png)
  }
  &.zjfw {
    background-image: url(~assets/images/ea_zjfw.png)
  }
  &.zzx {
    background-image: url(~assets/images/ea_zzx.png)
  }
  &.wxjp {
    background-image: url(~assets/images/ea_wxjp.png)
  }
  &.rdjj {
    background-image: url(~assets/images/ea_rdjj.png)
  }
  &.cyzb {
    background-image: url(~assets/images/ea_cyzb.png)
  }
} */
</style>



// WEBPACK FOOTER //
// src/views/TingSheng/expertAnalyse.vue